import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65e70a82&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=65e70a82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e70a82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\huixin\\云商\\V12_saas版\\erp-flexible-web21-cloud-saas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e70a82')) {
      api.createRecord('65e70a82', component.options)
    } else {
      api.reload('65e70a82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65e70a82&scoped=true", function () {
      api.rerender('65e70a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Page/index.vue"
export default component.exports